import { productLineOptions } from '../../internal'
import { modelFamilySystemView } from './model-family-system-view'
import { z } from 'my-zod'

export const modelFamilyCustomerView = modelFamilySystemView
  .pick({
    id: true,
    modelFamilyImageUrl: true,
    capacity: true,
    modelFamilyName: true
  })
  .augment({
    name: z.string(),
    productLine: z.enum(productLineOptions)
  })

export type modelFamilyCustomerView = z.infer<typeof modelFamilyCustomerView>
